<template>
	<div v-loading="totalloading">
	
		<el-card style="margin-top: 5px;">

			<el-steps size="mini" style="width: 800px;height: 20px;;margin-left: 315px;" v-if="!!flow"
				:active="flow.F_Step" finish-status="success" simple align-center>
				<el-step :title="i.F_FlowName" v-for="i in flowSetting"></el-step>
			</el-steps>

			<el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="margin-top: -33px;">
				<el-tab-pane label="订单信息" name="Order" v-loading="loading">
					<el-form :inline="true" :model="Info" size="mini" label-width="70px">
						<el-row>
							<el-row>

							</el-row>
							<el-col :span="6">
								<el-form-item label="订单号">
									<el-input size="mini" v-model="Info.F_OrderCode" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="备注">
									<el-input v-model="Info.Remark" :readonly="!isEdit" style="width: 450px;">
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-button type="success" @click="OpenPro" v-if="flow.F_Step==1&&isEdit&&Add"
									size="mini">新增商品</el-button>
								<el-button type="success" @click="OpenHdPro" size="mini"
									v-if="flow.F_Step==1&&isEdit&&hdAdd&&ishd">新增活动商品</el-button>
								<!-- <el-button type="primary" @click="printPro" size="mini" v-if="!isEdit">导出</el-button> -->
								<el-button type="danger" @click="EditChange" v-if="!isEdit&&flow.F_Step==1&&flow.F_AppealStep==0"
									size="mini">修改</el-button>
								<el-button type="danger" @click="EditChange" v-if="isEdit" size="mini">取消修改</el-button>
								<el-button type="primary" @click="OrderSave" v-if="flow.F_Step==1&& isAppeal==0&&isEdit"
									size="mini">保存订单</el-button>
								<el-button type="success" @click="SubmitOrder"
									v-if="flow.F_Step==1&&!isEdit&&flow.F_AppealStep!=1&&flow.F_AppealStep!=2" size="mini">提交订单
								</el-button>
								<el-button type="primary" @click="AppealCustomized"
									v-if="flow.F_Step==1&& isAppeal==0&&!isEdit&&!hdAdd" size="mini">定制申请</el-button>
									<el-button type="primary" @click="AppealCustomizedGC"
										v-if="flow.F_Step==1&& isAppeal==0&&!isEdit&&!hdAdd" size="mini">工程申请</el-button>
								<el-button type="primary" @click="AppealReturn" v-if="flow.F_AppealStep==1" size="mini">撤回政策申请
								</el-button>
								<el-button type="success" @click="OrderSuccess" v-if="flow.F_Step==6&&isEdit" size="mini">确认收货
								</el-button>
								<el-button type="danger" @click="back" size="mini" style="float: right;">关 闭</el-button>
								<el-button type="primary" @click="printPro" size="mini" v-if="!isEdit" style="float: right;">打印</el-button>								
								
							</el-col>
						</el-row>
					</el-form>
					<el-table ref="ordertable" :height="Tableheight" border :data="ProList" show-summary
						:summary-method="getSummaries" :stripe="true" :header-cell-style="{background:'#5a8642',color:'#ffffff',padding:'0'}">

						<el-table-column prop="F_MainImgCode" label="图片" width="125" align="center">
							<template slot-scope="scope">
								<el-image
									:src="'http://36.22.191.66:4005/'+scope.row['filepath']+scope.row['filename']+'_78x78.png'"
									class="img">
									<div slot="error">
										<i class="el-icon-picture-outline" style="font-size: 50px;"></i>
									</div>
								</el-image>
							</template>
						</el-table-column>
						<el-table-column prop="ProductName" label="编码/名称/整件规格/规格型号" align="center" min-width="250px"
							show-overflow-tooltip>
							<template slot-scope="scope">
								<a href="javascript:;" style="text-center: center;">
									<i style="font-style:normal;color: #000000;">{{ scope.row.ProductCode }}</i><br>
									<i style="font-style:normal;color: #000000;">{{ scope.row.ProductName }}</i><br>
									<i style="font-style:normal;color: #000000;">{{scope.row.整件规格}}</i><br>
									<i style="font-style:normal;color: #000000;">{{ scope.row.Standard }}</i>
								</a>
							</template>
						</el-table-column>
					
						<el-table-column prop="Number" label="件数" align="center" width="85">
							<template slot-scope="scope">
								<div v-if="isEdit">
									<el-input size="mini" v-model="scope.row.Number" @change="detailEdit(scope.row,'Number')"
										:readonly="!isEdit"></el-input>
								</div>
								<div v-else>
									{{scope.row.Number}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="sumnum" label="总数量" align="center" width="120">
							<template slot-scope="scope">
								<div v-if="scope.row.isCX=='True' && isEdit">
									
											
									<div style="float: left;line-height: 40px;width: 80px;"><el-input style="width: 70px;" size="mini" v-model="scope.row.sumnum" @change="detailEdit(scope.row,'sumnum')"></el-input></div>
									<div style="float: left;line-height: 40px;">	{{scope.row.Unit}}</div>
								</div>
								<div v-else>
									{{scope.row.sumnum+scope.row.Unit}}
								</div>
							</template>
						</el-table-column>
					
						<el-table-column prop="ProPrice" label=" 单价 " align="center" width="80">
							<template slot-scope="scope">
								<div>
									
									<i
										style="font-style:normal;color: #000000;">{{ parseFloat(parseFloat(scope.row.ProPrice).toFixed(2))}}</i><br>

								</div>
							</template>
						</el-table-column>
						<el-table-column prop="TotalPrice" label=" 金额 " align="center" width="100">
							<template slot-scope="scope">
								<div>
									
									<i
										style="font-style:normal;color: #000000;">{{ parseFloat(parseFloat(scope.row.TotalPrice).toFixed(2))}}</i><br>

									
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="useRebate" label=" 返利 " align="center" width="155">
							<template slot-scope="scope">
								<div v-if="isEdit">

								</div>
								<div v-else>

									<i style="font-style:normal;float: left;color: #000000;">{{'使用返利余额: '+ scope.row.useRebate}}</i><br>
<!-- <i style="font-style:normal;float: left;color: #000000;">{{'配件账户支付: '+ scope.row.usePJ}}</i><br>
<i style="font-style:normal;float: left;color: #000000;">{{'物料账户支付: '+scope.row.useWL}}</i><br> -->
								</div>

							</template>
						</el-table-column>
				

						<el-table-column prop="payTotalPrice" label=" 实付金额 " align="center" width="100">
							<template slot-scope="scope">
								<div v-if="isEdit">

								</div>
								<div v-else>

									<i
										style="font-style:normal;color: #000000;">{{ parseFloat(scope.row.payTotalPrice).toFixed(2)}}</i><br>

								</div>

							</template>
						</el-table-column>
						<el-table-column prop="Remarks" label="备注" min-width="150px" align="center">
							<template slot-scope="scope">
								<el-input size="mini" type="text" :rows="2" v-model="scope.row.Remarks"
									:readonly="!isEdit">
								</el-input>
							</template>
						</el-table-column>
						<el-table-column prop="ProPrice" label="优惠" align="center" min-width="120"
							show-overflow-tooltip>
							<template slot-scope="scope">
								<span style="font-style:normal;color: #000000;"
									v-if="scope.row.QX_TJ=='True'&& scope.row.OrderType!='QX_QD'">特价起订量为{{scope.row.TJsum==''? 0:Math.ceil(scope.row.TJsum/scope.row.onenum)}}件,特价{{parseFloat(parseFloat(scope.row.TJ_Price).toFixed(2))}}</span>
								<div v-else-if="(scope.row.QX_QD=='True'&& scope.row.OrderType=='QX_QD')||scope.row.spcode!=''"
									style="white-space:pre"><span style="display: block;font-style:normal;color: #000000;"
										v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.onenum)}}件，单价{{u.lvprice}}元</span>
								</div>
								<div v-else-if="scope.row.lvprice&&(scope.row.spcode!=''||scope.row.spcode!=null)"
									style="white-space:pre;"><span style="font-style:normal;color: #000000;"
										v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.onenum)}}件，单价{{u.lvprice}}元&nbsp;</span>
								</div>
								<span v-else>无</span>
							</template>
						</el-table-column>
						
						<el-table-column prop="onetiji" label="下单类型/体积" align="center" width="110">
							<template slot-scope="scope">
								<a href="javascript:;" style="text-center: center;">
									<i style="font-style:normal;color: #000000;">{{ scope.row.OrderTypeName }}</i><br>
									<i style="font-style:normal;color: #000000;">单体积:{{ scope.row.onetiji }}</i><br>
									<i style="font-style:normal;color: #000000;">总体积:{{ scope.row.suntiji }}</i><br>
								</a>
							</template>
						</el-table-column>
						<el-table-column prop="action" label="操作" width="60" >
							<template slot-scope="scope">
								<el-button @click.native.prevent="deletePro(scope.row)" type="text" size="mini"
									v-if="flow.F_Step==1&&isEdit">
									删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>

				

					<el-form :data="Info" :inline="true" :model="Info" size="mini" label-width="100px"
						style="margin-top: 20px;">
						<el-row>

						
							<el-col :span="6">
								<el-form-item label="订货单位">
									<el-input v-model="Info.F_CustomerName" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="订货日期">
									<el-input v-model="Info.Cdate" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="提交日期">
									<el-input v-model="Info.tijiaodate" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="审核日期">
									<el-input v-model="Info.shenhedate" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="账户余额">
									<el-input v-model="Info.txtzhanghumoney" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="合计订单金额">
									<el-input v-model="Info.TotalMoney" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6" v-if="flow.F_Step==1">
								<el-form-item label="使用返利金额">
									<el-input v-model="Info.flmoney" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6" v-if="flow.F_Step==1">
								<el-form-item label="实际支付金额">
									<el-input v-model="Info.paymoney" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>

							<el-col :span="6" v-if="flow.F_Step>=2">
								<el-form-item label="普通账户支付">
									<el-input v-model="Info.ptpay" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6" v-if="flow.F_Step>=2">
								<el-form-item label="返利账户支付">
									<el-input v-model="-Info.flpay" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6" v-if="flow.F_Step>=2">
								<el-form-item label="物料账户支付">
									<el-input v-model="Info.wlpay" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6" v-if="flow.F_Step>=2">
								<el-form-item label="配件账户支付">
									<el-input v-model="Info.pjpay" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>
						
							<el-col :span="6" v-if="flow.F_Step>=2">
								<el-form-item label="活动账户支付">
									<el-input v-model="Info.hdpay" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>
							
						</el-row>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="发货信息" name="Ship">
					<el-table :height="fhtopheight" :data="ShipList" row-key="cDLCode" v-loading="shiploading"
						@row-click="lookupShip">
						<el-table-column prop="cDLCode" label="发货单号" width="120" align="center">
						</el-table-column>
						<el-table-column prop="dDate" label="发货时间" width="180px" align="center">
						</el-table-column>
						<el-table-column prop="cVerifier" label="发货审核人" align="center" min-width="160px">
						</el-table-column>
						<el-table-column prop="dverifysystime" label="发货审核时间" align="center" min-width="180px">
						</el-table-column>
						<el-table-column prop="cmarker" label="操作" align="center" width="240px">
							<template slot-scope="scope">
								<el-button type="primary" size="mini" @click="lookupShip(scope.row)">查看</el-button>
								<el-button type="normal" size="mini" @click="printShip(scope.row)">打印</el-button>
								<el-button type="danger" size="mini" @click="delShip">删除</el-button>
							</template>
						</el-table-column>
						<el-table-column prop="isdel" label="提示" align="center" min-width="200px">
						</el-table-column>
						<el-table-column prop="wuliu" label="物流信息" align="center" min-width="200px">
						</el-table-column>
					</el-table>
					<el-table :height="fhbutheight" :data="OrderList" row-key="cinvcode" v-loading="orderloading">
						<el-table-column prop="BillsNumber" label="订单号" width="100" align="center">
						</el-table-column>
						<el-table-column prop="cWhName" label="仓库名称" width="120px" align="center">
						</el-table-column>
						<el-table-column prop="cinvcode" label="存货编码" align="center" min-width="120px">
						</el-table-column>
						<el-table-column prop="cinvname" label="存货名称" align="center" min-width="200px">
						</el-table-column>
						<el-table-column prop="cinvstd" label="规格型号" align="center" min-width="120px">
						</el-table-column>
						<el-table-column prop="cinvunit" label="单位" align="center" width="100px">
						</el-table-column>
						<el-table-column prop="iQuantity" label="总数量" align="center" width="120px">
						</el-table-column>
						<el-table-column prop="fwiQuantity" label="待发货数量" align="center" width="120px">
						</el-table-column>
						<el-table-column prop="fiQuantity" label="已发货数量" align="center" width="120px">
						</el-table-column>
					</el-table>
				</el-tab-pane>
			</el-tabs>
		
		</el-card>
		<el-dialog title="新增商品" :visible.sync="ProVisible" width="100%" top="0px" :modal="false">
			<el-form :inline="true" style="margin-top: -5px;" >
				<el-form-item>
					<span>关键词:</span>
					<el-input size="mini" v-model="keyword" style="width: 200px;margin:0 10px;"></el-input>
					<el-button size="mini" type="primary" @click="(pagination.page=1,onSubmit())"
						:disabled="!addproloading==0">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-select size="mini" v-model="value" placeholder="请选择" style="width:100px" @change="quanxian">
						<el-option size="mini" v-for="item in prooptions" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button @click="ProVisible = false" size="mini" type="danger">关 闭</el-button>
				</el-form-item>
			</el-form>
			<el-table :height='opencinvheight' v-loading="addproloading" :data="AddPro" style="width: 100%" 
			:header-cell-style="{background:'#5a8642',color:'#ffffff',padding:'0'}" stripe="true">

				<el-table-column prop="F_MainImgCode" label="图片" width="125px" align="center">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<el-image
								:src="'http://36.22.191.66:4005/'+scope.row['filepath']+scope.row['filename']+'_78x78.png'"
								class="img">
								<div slot="error">
									<i class="el-icon-picture-outline" style="font-size: 80px;"></i>
								</div>
							</el-image>
						</a>
					</template>
				</el-table-column>
				<el-table-column prop="F_ClassName" label="编码/名称/整件规格/规格型号" align="center" minWidth="300px">
					<template slot-scope="scope">
						<a href="javascript:;" @click="handleProductClick(scope.row['F_ProductCode'])"
							style="text-center: center;">
							<i style="font-style:normal;color: #000000;">{{ scope.row.F_ProductCode }}</i><br>
							<i style="font-style:normal;color: #000000;">{{ scope.row.F_ClassName }}</i><br>
							<i style="font-style:normal;color: #000000;">{{scope.row.整件规格}}</i><br>
							<i style="font-style:normal;color: #000000;">{{ scope.row.F_SpecText }}</i><br>
						</a>
					</template>
				</el-table-column>

				<el-table-column prop="lv" label="优惠" align="center" show-overflow-tooltip   min-width="150px">
					<template slot-scope="scope">
						<span
							v-if="scope.row.QX_TJ&&scope.row.TJsum!=null&& value!='QX_QD'">特价起订量为{{scope.row.TJsum==''? 0:Math.ceil(scope.row.TJsum/scope.row.F_UnitRate)}}件,特价{{parseFloat(parseFloat(scope.row.TJ_Price).toFixed(2))}}</span>
						<div v-else-if="(scope.row.lvprice!=[]|| scope.row.lvprice!='')&& value=='QX_QD'"
							style="white-space:pre"><span style="display: block"
								v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.F_UnitRate)}}件，单价{{u.lvprice}}元&nbsp;</span>
						
						</div>
						<div v-else-if="(scope.row.lvprice!=[]|| scope.row.lvprice!='')&& value=='QX_PT'" style="white-space:pre"><span style="display: block"
							 v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.F_UnitRate)}}件，单价{{u.lvprice}}元&nbsp;</span></div>
						<span v-else>无</span>
					</template>
				</el-table-column>
				
				<el-table-column prop="price" label="单价" align="center" min-width="80px">
					<template slot-scope="scope">
						{{ scope.row.price}}
					</template>
				</el-table-column>
				<el-table-column label="件数" min-width="139px" align="center">
					<template slot-scope="scope">
						<el-input-number @change="numprice(scope.row)" v-model="scope.row.num" :min="1" :max="99999"
							size="mini" style="width: 115px;"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column prop="TotalNum" label="总数量" align="center" min-width="80px">
					<template slot-scope="scope">
						{{ parseFloat((scope.row.num*scope.row.F_UnitRate).toFixed(2)) }}{{scope.row.F_UnitText}}
					</template>
				</el-table-column>
				<el-table-column prop="TotalMoney" label="总金额" align="center" min-width="80px">
					<template slot-scope="scope">
						{{ parseFloat((scope.row.num*scope.row.F_UnitRate*scope.row.price).toFixed(2)) }}
					</template>
				</el-table-column>
				<!-- <el-table-column prop="CustPrice" label="库存" align="center" width="80px">
					<template slot-scope="scope">
						{{ scope.row.F_Stock }}
					</template>
				</el-table-column> -->
				<el-table-column prop="action" label="操作" min-width="80">
					<template slot-scope="scope">
						<el-button @click.native.prevent="SavePro(scope.row)" type="text" size="mini"
							:loading="scope.row.F_Disabled">
							选入产品
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination style="margin-top: 20px;" @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[10,20,50,100]"
				:page-size="pagination.rows" layout="total, sizes, prev, pager, next, jumper"
				:total="pagination.records">
			</el-pagination>
			
		</el-dialog>
		<el-dialog :visible.sync="HdProVisible" width="100%" top="0" :modal="false">
			<el-form :inline="true" style="margin-top: -15px;margin-bottom: -10px;">
				<el-form-item>
					<span>关键词:</span>
					<el-input size="mini" v-model="Hdkeyword" style="width: 200px;margin:0 10px;"></el-input>
					<el-button size="mini" type="primary" @click="(Hdpagination.page=1,onHdSubmit())"
						:disabled="!loading==0">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button size="mini" type="danger" style="margin-bottom: 10px;" @click="HdProVisible = false">
						关闭并回到订单</el-button>
				</el-form-item>
			</el-form>
			<el-table :height="opencinvheight" size="mini" :stripe="true" v-loading="loading" :data="AddHdPro"
				style="width: 100%">

				<el-table-column prop="F_MainImgCode" label="图片" width="125px" align="center">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<el-image
								:src="'http://36.22.191.66:4005/'+scope.row['filepath']+scope.row['filename']+'_78x78.png'"
								class="img">
								<div slot="error">
									<i class="el-icon-picture-outline" style="font-size: 60px;"></i>
								</div>
							</el-image>
						</a>
					</template>
				</el-table-column>
				<el-table-column prop="F_ClassName" label="编码/名称/整件规格/规格型号" align="center" min-width="300px">
					<template slot-scope="scope">
						<a href="javascript:;" @click="handleProductClick(scope.row['F_ProductCode'])"
							style="text-center: center;">
							<i style="font-style:normal;color: #004085;">{{ scope.row.F_ProductCode }}</i><br>
							<i style="font-style:normal;color: #004085;">{{ scope.row.F_ClassName }}</i><br>
                            <i style="font-style:normal;color: #004085;">{{ scope.row.整件规格 }}</i><br>
						<i style="font-style:normal;color: #004085;">{{ scope.row.F_SpecText }}</i><br>
						</a>
					</template>
				</el-table-column>
				<el-table-column prop="lv" label="优惠" align="center" min-width="200px" show-overflow-tooltip>
					<template slot-scope="scope">
						<div v-if="scope.row.lvprice" style="white-space:pre"><span style="display: block"
								v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.F_UnitRate)}}件，单价{{u.lvprice}}元&nbsp;</span>
						</div>
						<span v-else>无</span>
					</template>
				</el-table-column>
				
				<el-table-column prop="price" label="单价" align="center" min-width="80px">
					<template slot-scope="scope">
						{{ scope.row.price|showPrice() }}
					</template>
				</el-table-column>
				<el-table-column label="件数" min-width="139px" align="center">
					<template slot-scope="scope">
						<el-input-number v-model="scope.row.num" :min="1" :max="999999" @change="changehdnum(scope.row)"
							size="mini" style="width: 115px;"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column prop="TotalNum" label="总数量" align="center" min-width="80px">
					<template slot-scope="scope">
						{{ parseFloat((scope.row.num*scope.row.F_UnitRate).toFixed(2)) }}
					</template>
				</el-table-column>
				<el-table-column prop="TotalMoney" label="总金额" align="center" min-width="80px">
					<template slot-scope="scope">
						{{ (scope.row.num*scope.row.F_UnitRate*scope.row.price).toFixed(2) }}
					</template>
				</el-table-column>
				<!-- <el-table-column prop="CustPrice" label="库存" align="center" width="80px">
					<template slot-scope="scope">
						{{ scope.row.F_Stock }}
					</template>
				</el-table-column> -->
				<el-table-column prop="action" label="操作" min-width="80">
					<template slot-scope="scope">
						<el-button @click.native.prevent="SaveHdPro(scope.row)" type="text" size="mini"
							:loading='scope.row.F_Disabled'>
							选入产品
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination style="margin-top: 0px;" @size-change="hdhandleSizeChange"
				@current-change="hdhandleCurrentChange" :current-page="Hdpagination.page" :page-sizes="[10,20,50,100]"
				:page-size="Hdpagination.rows" layout="total, sizes, prev, pager, next, jumper"
				:total="Hdpagination.records">
			</el-pagination>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" style="margin-bottom: 10px;" @click="HdProVisible = false" type="danger">关 闭
				</el-button>
			</span>
		</el-dialog>

		<el-dialog title="配套购买提醒" :visible.sync="ProMatchVisible" width="100%" top="30px" :before-close="handleClose"
			:modal="false">
			<el-table :height="opencinvheight" :data="ProMatch" ref="matchtable" style="width: 100%;margin-bottom: 20px;"
				row-key="ProductCode" border default-expand-all selection-change="handleSelectionChange"
				@select="select" @select-all="selectall"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="chzt" label="说明">
					<template slot-scope="scope">
						<span v-if="scope.row.isgou=='True'" style="color: red;">
							scope.row.chzt
						</span>
						<span v-else >
							scope.row.isgou
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="OrderType" label="下单类型" align="center" width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.OrderType=='QX_PT'">
							普通
						</span>
						<span v-else-if="scope.row.OrderType=='QX_DS'">
							电商
						</span>
						<span v-else-if="scope.row.OrderType=='QX_QD'">
							渠道
						</span>
						<span v-else-if="scope.row.OrderType=='QX_TJ'">
							特价
						</span>
						<!-- <span v-else-if="scope.row.OrderType=='QX_PJ'">
							配件
						</span>
						<span v-else-if="scope.row.OrderType=='QX_WL'">
							物料
						</span> -->
					</template>
				</el-table-column>
				<el-table-column prop="F_MainImgCode" label="图片" width="125px" align="center">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<el-image
								:src="'http://36.22.191.66:4005'+scope.row['filepath']+scope.row['filename']+'_78x78.png'"
								class="img">
								<div slot="error">
									<i class="el-icon-picture-outline" style="font-size: 80px;"></i>
								</div>
							</el-image>
						</a>
					</template>
				</el-table-column>
				<el-table-column prop="ProductName" label="编码/名称" align="center" min-width="300px">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<i style="font-style:normal;color: #004085;">{{ scope.row.ProductCode }}</i><br>
							<i style="font-style:normal;color: #004085;">{{ scope.row.ProductName }}</i><br>
                            <i style="font-style:normal;color: #004085;">{{ scope.row.整件规格 }}</i><br>
						<i style="font-style:normal;color: #004085;">{{ scope.row.Standard }}</i><br>
						</a>
					</template>
				</el-table-column>
				<el-table-column prop="lvprice" label="优惠" align="center" min-width="200" show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.QX_TJ&&scope.row.TJsum!=null&& value!='QX_QD'">特价起订量为
							{{scope.row.TJsum==''? 0:Math.ceil(scope.row.TJsum/scope.row.F_UnitRate)}}
							件,特价 {{parseFloat(parseFloat(scope.row.TJ_Price).toFixed(2))}} 元</span>
						<div v-else-if="(scope.row.lvprice!=[]|| scope.row.lvprice!='')&& value=='QX_QD'"
							style="white-space:pre"><span style="display: block"
								v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.F_UnitRate)}}件，单价{{u.lvprice}}元&nbsp;</span>
						</div>
						<span v-else>无</span>
					</template>
				</el-table-column>
				
				<el-table-column prop="Number" label="件数" align="center" min-width="80">
					<template slot-scope="scope">
						<div>
							<el-input size="mini" v-model="scope.row.Number" @change="matchEdit(scope.row,'Number')"
								:disabled="scope.row.children!=undefined"></el-input>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="sumnum" label="总数量" align="center" min-width="80">
					<template slot-scope="scope">
						<div>
							<el-input size="mini" v-model="scope.row.sumnum" @change="matchEdit(scope.row,'sumnum')"
								:disabled="scope.row.children!=undefined"></el-input>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="ProPrice" label="销售单价" align="center" min-width="85">
					<template slot-scope="scope">
						<div>
							<i
								style="font-style:normal;color: #004085;">{{ parseFloat(parseFloat(scope.row.ProPrice).toFixed(2))}}</i><br>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="TotalPrice" label="金额" align="center" min-width="100">
					<template slot-scope="scope">
						<div>
							{{ parseFloat(parseFloat(scope.row.TotalPrice).toFixed(2))}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="onetiji" label="体积" align="center" min-width="80">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<i style="font-style:normal;color: #004085;">单:{{ scope.row.onetiji }}</i><br>
							<i style="font-style:normal;color: #004085;">总:{{ scope.row.suntiji }}</i><br>
						</a>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" type="primary" @click="SaveProMatch">选入配套产品</el-button>
				<el-button size="mini" @click="ProMatchVisible = false" type="danger">关 闭</el-button>
			</span>
		</el-dialog>
		<el-dialog title="龙骨购买提醒" :visible.sync="peitiVisible" width="100%" top="30px" :before-close="handleClose"
			:modal="false">
			<el-table :height="opencinvheight" :stripe="true" :data="peitiData" ref="peititable"
				style="width: 100%;margin-bottom: 20px;" row-key="ProductCode" border default-expand-all>
				<el-table-column type="selection" width="40">
				</el-table-column>
				<el-table-column prop="OrderType" label="下单类型" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.OrderType=='QX_PT'">
							普通
						</span>
						<span v-else-if="scope.row.OrderType=='QX_DS'">
							电商
						</span>
						<span v-else-if="scope.row.OrderType=='QX_QD'">
							渠道
						</span>
						<span v-else-if="scope.row.OrderType=='QX_TJ'">
							特价
						</span>
						<!-- <span v-else-if="scope.row.OrderType=='QX_PJ'">
							配件
						</span>
						<span v-else-if="scope.row.OrderType=='QX_WL'">
							物料
						</span> -->
					</template>
				</el-table-column>
				<el-table-column prop="F_MainImgCode" label="图片" width="125px" align="center">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<el-image
								:src="'http://36.22.191.66:4005'+scope.row['filepath']+scope.row['filename']+'_78x78.png'"
								class="img">
								<div slot="error">
									<i class="el-icon-picture-outline" style="font-size: 80px;"></i>
								</div>
							</el-image>
						</a>
					</template>
				</el-table-column>
				<el-table-column prop="ProductName" label="编码/名称" align="center" min-width="300px">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<i style="font-style:normal;color: #004085;">{{ scope.row.ProductCode }}</i><br>
							<i style="font-style:normal;color: #004085;">{{ scope.row.ProductName }}</i><br>
							<i style="font-style:normal;color: #004085;">{{ scope.row.整件规格 }}</i><br>
							<i style="font-style:normal;color: #004085;">{{ scope.row.Standard }}</i><br>
						</a>
					</template>
				</el-table-column>
			
				<el-table-column prop="Number" label="件数" align="center" min-width="80">
					<template slot-scope="scope">
						<div>
							<el-input size="mini" v-model="scope.row.Number" @change="peitiEdit(scope.row,'Number')"
								:disabled="scope.row.children!=undefined"></el-input>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="sumnum" label="总数量" align="center" min-width="80">
					<template slot-scope="scope">
						<div>
							<el-input size="mini" v-model="scope.row.sumnum" @change="peitiEdit(scope.row,'sumnum')"
								:disabled="scope.row.children!=undefined"></el-input>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="Sumstockbalance" label="需求总数量" min-width="100px" align="center">
				</el-table-column>
				<el-table-column prop="ProPrice" label="销售单价" align="center" min-width="85">
					<template slot-scope="scope">
						<div>
							<i
								style="font-style:normal;color: #004085;">{{ parseFloat(parseFloat(scope.row.ProPrice).toFixed(2))}}</i><br>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="TotalPrice" label="金额" align="center" min-width="100">
					<template slot-scope="scope">
						<div>
							{{ parseFloat(parseFloat(scope.row.TotalPrice).toFixed(2))}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="onetiji" label="体积" align="center" min-width="80">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<i style="font-style:normal;color: #004085;">单:{{ scope.row.onetiji }}</i><br>
							<i style="font-style:normal;color: #004085;">总:{{ scope.row.suntiji }}</i><br>
						</a>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="SavePeiti">选入龙骨并保存订单</el-button>
				<el-button @click="peitiVisible = false" type="danger">关 闭</el-button>
			</span>
		</el-dialog>
		<el-dialog title="订单扣款信息" :visible.sync="SubmitVisible" width="600px" top="30px" :before-close="handleClose"
			:modal="false">
			<el-form :disabled="true">
				<el-form-item>
					<span>订单总金额:</span>
					<span style="color: red;margin-left: 10px;">{{SubmitData.ordermoney}}</span>
					<!-- <span style="margin-left: 10px;"> 使用返利金额:</span>
					<span style="color: red;margin-left: 10px;">{{SubmitData.orderflmoney}}</span>
					<span style="margin-left: 10px;">需支付金额:</span>
					<span style="color: red;margin-left: 10px;">{{SubmitData.orderpaymoney}}</span> -->
				</el-form-item>
			</el-form>
			<el-form>

				<table style="font-size: 15px;">
					<tr>
						<td>普通账户余额:</td>
						<td style="width: 80px;text-align:right;"><span
								style="color: green;margin-left: 10px;width: 100px;">{{SubmitData.pt}}</span>&nbsp;元</td>
						<td style="width: 60px;text-align:right;">需支付:</td>
						<td style="width: 80px;text-align:right;"><span
								style="color: red;margin-left: 10px;width: 50px;">{{SubmitData.ptmoney}}</span>&nbsp;元</td>
						<td style="width: 50px;text-align:right;">剩余:</td>
						<td style="width: 80px;text-align:right;"><span
								style="color: green;margin-left: 10px;width: 50px;">{{SubmitData.ptbalance}}</span>&nbsp;元</td>
					</tr>
					<tr>
						<td>返利账户余额:</td>
						<td style="width: 80px;text-align:right;"><span
								style="color: green;margin-left: 10px;width: 100px;">{{SubmitData.fl}}</span>&nbsp;元</td>
						<td style="width: 60px;text-align:right;">需支付:</td>
						<td style="width: 80px;text-align:right;"><span
								style="color: red;margin-left: 10px;width: 50px;">{{SubmitData.flmoney}}</span>&nbsp;元</td>
						<td style="width: 50px;text-align:right;">剩余:</td>
						<td style="width: 80px;text-align:right;"><span
								style="color: green;margin-left: 10px;width: 50px;">{{SubmitData.flbalance}}</span>&nbsp;元</td>
					</tr>
					<!-- <tr>
						<td>配件账户余额:</td>
						<td style="width: 80px;text-align:right;"><span
								style="color: green;margin-left: 10px;width: 100px;">{{SubmitData.pj}}</span>&nbsp;元</td>
						<td style="width: 60px;text-align:right;">需支付:</td>
						<td style="width: 80px;text-align:right;"><span
								style="color: red;margin-left: 10px;width: 50px;">{{SubmitData.pjmoney}}</span>&nbsp;元</td>
					<td style="width: 50px;text-align:right;">剩余:</td>
						<td style="width: 80px;text-align:right;"><span
								style="color: green;margin-left: 10px;width: 50px;">{{SubmitData.pjbalance}}</span>&nbsp;元</td>
					</tr>
					<tr>
						<td>物料账户余额:</td>
						<td style="width: 80px;text-align:right;"><span
								style="color: green;margin-left: 10px;width: 100px;">{{SubmitData.wl}}</span>&nbsp;元</td>
						<td style="width: 60px;text-align:right;">需支付:</td>
						<td style="width: 80px;text-align:right;"><span
								style="color: red;margin-left: 10px;width: 50px;">{{SubmitData.wlmoney}}</span>&nbsp;元</td>
						<td style="width: 50px;text-align:right;">剩余:</td>
						<td style="width: 80px;text-align:right;"><span
								style="color: green;margin-left: 10px;width: 50px;">{{SubmitData.wlbalance}}</span>&nbsp;元</td>
					</tr> -->
</table>
				
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="Submit" size="mini">确认支付</el-button>
				<el-button @click="SubmitVisible = false" size="mini">取 消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="活动订单扣款信息" :visible.sync="hdSubmitVisible" width="700px" top="30px" :before-close="handleClose"
			:modal="false">
			<el-form :disabled="true">
				<el-form-item>
					<span>订单总金额:</span>
					<span style="color: red;margin-left: 30px;">{{SubmitData.ordermoney}}</span>
				</el-form-item>
				<el-form-item>
					<span>使用返利金额:</span>
					<span style="color: red;margin-left: 30px;">{{SubmitData.orderflmoney}}</span>
				</el-form-item>
				<el-form-item>
					<span>需支付金额:</span>
					<span style="color: red;margin-left: 30px;">{{SubmitData.orderpaymoney}}</span>
				</el-form-item>
			</el-form>
			<el-form :disabled="true">
				<el-row :gutter="24">
					<el-col :span="12">
						<el-form-item>
							<el-col :span="10">
								<span>活动账户余额:</span>
							</el-col>
							<el-col :span="12">
								<el-input v-model="SubmitData.hd"></el-input>
							</el-col>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item>
							<el-col :span="10">
								<span>活动账户支付金额:</span>
							</el-col>
							<el-col :span="12">
								<el-input v-model="SubmitData.hdmoney"></el-input>
							</el-col>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="Submit" size="mini">确认支付</el-button>
				<el-button @click="hdSubmitVisible = false" size="mini">取 消</el-button>
			</span>
		</el-dialog>


		<el-dialog title="打印发货信息" :visible.sync="PrintVisible" width="100%" top="0px" :before-close="handleClose"
			:modal="false">
			<div style="text-align: center;font-size: 24px !important;font-weight: bold;">奥华发货信息单</div>
			<el-form data="printForm" :inline="true">
				<el-row>
					<el-col :span="12">
						<el-form-item label="销售单号:">
							{{printForm.BillsNumber}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="发货单号:">
							{{printForm.cdlcode}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="订货单位:">
							{{printForm.OrderUnit}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="订货地址:">
							{{printForm.DeliveryAddress}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="提交日期:">
							{{printForm.tijiaodate}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="审核日期:">
							{{printForm.shenhedate}}
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="联系人:">
							{{printForm.Contacter}}
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="手机号:">
							{{printForm.Phone}}
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="联系电话:">
							{{printForm.Telephone}}
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注:">
							{{printForm.beizhu}}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<el-table :height="Tableheight" :data="printList">
				<el-table-column prop="id" label="序号" width="50"></el-table-column>
				<el-table-column prop="cinvcode" label="存货编码" width="100"></el-table-column>
				<el-table-column prop="cinvname" label="存货名称" width="200"></el-table-column>
				<el-table-column prop="cinvstd" label="规格型号" width="120"></el-table-column>
				<el-table-column prop="cinvunit" label="单位" width="60"></el-table-column>
				<el-table-column prop="fiQuantity" label="已发数量" width="100"></el-table-column>
				<el-table-column prop="fwiQuantity" label="待发数量" width="100"></el-table-column>
				<el-table-column prop="beizhus" label="备注"></el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="print" size="mini">打印</el-button>
				<el-button @click="PrintVisible = false" size="mini" type="danger">关 闭</el-button>
			</span>
		</el-dialog>

		<el-dialog title="打印订单信息" :visible.sync="PrintProVisible"   width="1200px"   top="0px" :before-close="handleClose"
			:modal="false">
			<div style="text-align: center;font-size: 24px !important;font-weight: bold;">奥华产品信息单</div>
			<el-form :inline="true" :model="Info" size="mini" label-width="70px" 
				style="font-weight: bold;color: #000000;">
				<el-row>
					<el-col :span="6">
						<el-form-item label="订单号">
							{{Info.F_OrderCode}}
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="提交日期">
							{{Info.tijiaodate}}
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="审核日期">
							{{Info.shenhedate}}
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="订货日期">
							{{Info.Cdate}}
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="订货单位">
							{{Info.F_CustomerName}}
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="订货地址">
							{{Info.DeliveryAddress}}
						</el-form-item>
					</el-col>

					<el-col :span="6">
						<el-form-item label="联系人">
							{{Info.Contacter}}
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="手机号">
							{{Info.Phone}}
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="联系电话">
							{{Info.Telephone}}
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="返利单号">
							{{Info.flcode}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="备注">
							{{Info.Remark}}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<el-table :height="printtableheight"  id="outTable" :data="ProList" border style="font-weight: bold;">
				<el-table-column prop="ProductCode" label="编码" align="center" min-width="120px" style="font-weight: bold;">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<i style="font-style:normal;color: #000000;">{{ scope.row.ProductCode }}</i><br>
						</a>
					</template>
				</el-table-column>
				<el-table-column prop="ProductName" label="名称" align="center" min-width="300px" style="font-weight: bold;">
					<template slot-scope="scope">
						<i style="font-style:normal;color: #000000;">{{ scope.row.ProductName }}</i><br>

					</template>
				</el-table-column>
				<el-table-column prop="Standard" label="规格型号" align="center" min-width="300px" style="font-weight: bold;">
					<template slot-scope="scope">
						<i style="font-style:normal;color: #000000;">{{ scope.row.Standard }}</i><br>
					</template>
				</el-table-column>
				<el-table-column prop="stdd" label="单位" align="center" min-width="60px" style="font-weight: bold;">
					<template slot-scope="scope">
						<i style="font-style:normal;color: #000000;">{{ scope.row.Unit }}</i><br>
					</template>
				</el-table-column>
				<el-table-column prop="sumnum" label="总数量" align="center" min-width="80" style="font-weight: bold;">
					<template slot-scope="scope">
						<i style="font-style:normal;color: #000000;">{{ scope.row.sumnum }}</i><br>
					</template>
				</el-table-column>
				<el-table-column prop="Remarks" label="备注" min-width="180px" style="font-weight: bold;">
					<template slot-scope="scope">
						<i style="font-style:normal;color: #000000;">{{ scope.row.Remarks }}</i><br>
					</template>
				</el-table-column>

			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" size="mini" @click="print">打印</el-button>
				<el-button type="primary" size="mini" @click="ExportPro">导出</el-button>
				<el-button size="mini" @click="PrintProVisible = false" type="danger">关 闭</el-button>
			</span>
		</el-dialog>
	</div>

</template>

<script>
	import request from '@/utils/request'
	import XLSX from 'xlsx';
	export default {
		props: {
			BillsNumber: '',
		},
		data() {
			return {
				opencinvheight:'300px',
				totalloading: true,
				isEdit: false, //是否修改
				Info: {},
				ProList: [],
				delPro: [],
				Ship: "",
				Wuliu: "",
				flow: {},
				flowSetting: [],
				activeName: 'Order',
				ProVisible: false,
				SelectPro: [], //选中的商品
				AddPro: [], //商品列表
				AddHdPro: [], //商品列表
				pagination: {
					rows: 10,
					page: 1
				},
				Hdpagination: {
					rows: 10,
					page: 1
				},
				HdProVisible: false,
				Hdkeyword: "",
				keyword: "",
				flowappeal: [],
				isAppeal: false,
				prooptions: [{
					value: 'QX_PT',
					label: '普通',
					key: 'QX_PT',
				}, {
					value: 'QX_QD',
					label: '渠道',
					key: 'QX_QD',
				}, {
					value: 'QX_DS',
					label: '电商',
					key: 'QX_DS',
				}, {
					value: 'QX_TJ',
					label: '特价',
					key: 'QX_TJ',
				},
				// {
				// 	value: 'QX_PJ',
				// 	label: '配件',
				// 	key: 'QX_PJ',
				// }, {
				// 	value: 'QX_WL',
				// 	label: '物料',
				// 	key: 'QX_WL',
				// },
				{
					value: 'QX_YT',
					label: '阳台',
					key: 'QX_YT',
				}],
				options: [{
					value: 'QX_PT',
					label: '普通',
					key: 'QX_PT',
				}, {
					value: 'QX_QD',
					label: '渠道',
					key: 'QX_QD',
				}, {
					value: 'QX_DS',
					label: '电商',
					key: 'QX_DS',
				}, {
					value: 'QX_TJ',
					label: '特价',
					key: 'QX_TJ',
				}, 
				// {
				// 	value: 'QX_PJ',
				// 	label: '配件',
				// 	key: 'QX_PJ',
				// }, {
				// 	value: 'QX_WL',
				// 	label: '物料',
				// 	key: 'QX_WL',
				// },
				{
					value: 'QX_HD',
					label: '活动',
					key: 'QX_HD',
				},{
					value: 'QX_YT',
					label: '阳台',
					key: 'QX_YT',
				}],
				value: "QX_PT",
				issaved: 0,
				ProMatchVisible: false,
				ProMatch: [], //配套产品
				peitiVisible: false,
				peitiData: [], //龙骨产品信息
				loading: true,
				TableHeight: 500,
				fhtopheight:300,
				fhbutheight:300,
				//tableheight: 500,
				printtableheight:500,
				SubmitData: {
					ordermoney: 0,
					orderflmoney: 0,
					orderpaymoney: 0,
					pt: 0,
					ptmoney: 0,
					fl: 0,
					flmoney: 0,
					pj: 0,
					pjmoney: 0,
					wl: 0,
					wlmoney: 0,
					hd: 0,
					hdmoney: 0,
				},
				SubmitVisible: false,
				hdSubmitVisible: false,
				addproloading: true,
				ShipHeight: 400,
				ShipList: [],
				OrderList: [],
				shiploading: true,
				orderloading: true,
				wuliuloading: true,
				PrintVisible: false,
				printList: [],
				printForm: {
					BillsNumber: '',
					cdlcode: '',
					OrderUnit: '',
					DeliveryAddress: '',
					tijiaodate: '',
					shenhedate: '',
					Contacter: '',
					Phone: '',
					Telephone: '',
					beizhu: '',
				},
				PrintProVisible: false,
				hdAdd: true,
				Add: true,
				ishd: true,
			}
		},
		created() {
			//this.$route.query.F_OrderCode=this.BillsNumber
			this.onload()
			this.Tableheight = (document.documentElement.clientHeight - 265) + "px"
			this.opencinvheight=(document.documentElement.clientHeight - 155) + "px"
			this.printtableheight = (document.documentElement.clientHeight - 270) + "px"
			this.fhtopheight="200px"
			this.fhbutheight=(document.documentElement.clientHeight - 330) + "px"
			window.onresize = () => {
				this.Tableheight = (document.documentElement.clientHeight - 265) + "px"
				this.opencinvheight=(document.documentElement.clientHeight - 155) + "px"
					this.printtableheight = (document.documentElement.clientHeight - 270) + "px"
				this.fhbutheight=(document.documentElement.clientHeight - 330) + "px"
			}
			
		},
		beforeDestroy() {

		},
		updated() {
			this.$nextTick(() => {
				this.$refs['ordertable'].doLayout();
			})
		},
		watch: {
			"BillsNumber": {
				handler() {
					this.onload();
				}
			}
			/* BillsNumber:{
				this.OrderFlow()
				this.OrderDetail()
			} */
			/*ProList:{
				handler(newval){
						var sum = 0;
						for (var i = 0; i < this.ProList.length; i++) {
							this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onenum)).toFixed(
								2))
							this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].ProPrice)).toFixed(2)
							this.ProList[i].YTotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].YProPrice)).toFixed(2)
							this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onetiji)).toFixed(2)
							sum += parseFloat(this.ProList[i].TotalPrice)
						}
						this.Info.TotalMoney = parseFloat(sum.toFixed(2))
						this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2)
				},
				deep:true,
			},
			'ProList.OrderType': {
				handler(newVal) {
						var sum = 0;
						for (var i = 0; i < this.ProList.length; i++) {
							this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onenum)).toFixed(
								2))
							this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].ProPrice)).toFixed(2)
							this.ProList[i].YTotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].YProPrice)).toFixed(2)
							this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onetiji)).toFixed(2)
							sum += parseFloat(this.ProList[i].TotalPrice)
						}
						this.Info.TotalMoney = parseFloat(sum.toFixed(2))
						this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2)
				},
				immediate: false,
			},
			'ProList.Number': {
				handler(newVal) {
					console.log(1)
						var sum = 0;
						for (var i = 0; i < this.ProList.length; i++) {
							this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onenum)).toFixed(
								2))
							this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].ProPrice)).toFixed(2)
							this.ProList[i].YTotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].YProPrice)).toFixed(2)
							this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onetiji)).toFixed(2)
							sum += parseFloat(this.ProList[i].TotalPrice)
						}
						this.Info.TotalMoney = parseFloat(sum.toFixed(2))
						this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2)
				},
				immediate: false,
			}*/
		},
		methods: {
			onload() {

				this.isEdit = false
				this.SubmitVisible = false
				this.OrderFlow()
				this.OrderDetail()
				//console.log(this.BillsNumber)
			},
			//计算价格
			count() {
				var sum = 0;
				for (var i = 0; i < this.ProList.length; i++) {
					this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i]
						.onenum)).toFixed(
						2))
					this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i]
						.ProPrice)).toFixed(2)
					this.ProList[i].YTotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i]
						.YProPrice)).toFixed(
						2)
					this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onetiji))
						.toFixed(2)
					this.ProList[i].payTotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i]
						.ProPrice) - parseFloat(this.ProList[i].useRebate)).toFixed(
						2)
					sum += parseFloat(this.ProList[i].TotalPrice)
				}
				this.Info.TotalMoney = parseFloat(sum.toFixed(2))
				this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2)
			},
			//更改查询类型
			quanxian(val) {
				this.value = val
				this.pagination.page = 1
				this.onSubmit()
			},
			//查询商品
			onSubmit() {
				this.addproloading = true
				request({
					url: '/DRPAPI.ashx?a=getpagelist',
					method: 'get',
					data: {
						pagination: JSON.stringify(this.pagination),
						queryJson: JSON.stringify({
							keyword: this.keyword,
							F_CategoryId: null,
							quanxian: this.value,
						})
					}
				}).then(res => {
					//alert(1)
					this.addproloading = false
					this.pagination.page = res.data.page
					this.pagination.records = res.data.records
					this.pagination.total = res.data.total

					res.data.rows.forEach(item => {
						this.$set(item, "F_Disabled", false)
						if (item.F_Stock === null) {
							this.$set(item, "F_Stock", 0)
							this.$set(item, "num", 0)
						} else {
							this.$set(item, "num", 1)
						}
					})
					this.AddPro = res.data.rows
					var adddata = "";
					this.AddPro.forEach(item => {
						adddata += item.F_ProductCode + '@'
					})
					adddata = adddata.substring(0, adddata.length - 1)
					if (this.value == "QX_QD"||this.value == "QX_PT") {
							//alert(2)
						request({
							url: '/DRPORDERAPI.ashx?a=getlvpriceinfo',
							method: 'post',
							data: {
								F_ProductId: adddata,
								F_CustomerId: this.$store.state.user.F_CustomerId,
								OrderType: this.value
							}
						}).then(res => {
							for (var j = 0; j < this.AddPro.length; j++) {
								this.AddPro[j].lvprice = []
								for (var i = 0; i < res.data.length; i++) {

									if (this.AddPro[j].F_ProductCode == res.data[i].cinvcode) {
										this.AddPro[j].lvprice.push(res.data[i])
									}

								}
							}
							for (var i = 0; i < this.AddPro.length; i++) {
								for (var j = 0; j < this.AddPro[i].lvprice.length; j++) {
									
									if(this.value == "QX_QD")
									{
										if (this.AddPro[i].lvprice[j].lvwhere != '' && this.AddPro[i].num >= Math.ceil(this.AddPro[i].lvprice[j].lvwhere /
												this.AddPro[i].F_UnitRate)) {
											this.AddPro[i].price = this.AddPro[i].lvprice[j].lvprice
											break
										} else if (this.AddPro[i].num < Math.ceil(this.AddPro[i].lvprice[j].lvwhere / this.AddPro[i].F_UnitRate)) {
											this.AddPro[i].price = this.AddPro[i].QD_Price
											break
										}
										
									}
									if(this.value == "QX_PT")
									{
										if (this.AddPro[i].lvprice[j].lvwhere != '' && this.AddPro[i].num >= Math.ceil(this.AddPro[i].lvprice[j].lvwhere /
												this.AddPro[i].F_UnitRate)) {
											this.AddPro[i].price = this.AddPro[i].lvprice[j].lvprice
											break
										} else if (this.AddPro[i].num < Math.ceil(this.AddPro[i].lvprice[j].lvwhere / this.AddPro[i].F_UnitRate)) {
											this.AddPro[i].price = this.AddPro[i].PT_Price
											break
										}
										
									}
								}
							}
						})
					} else if (this.value == "QX_TJ" || this.value == "QX_PT") {
						for (var i = 0; i < this.AddPro.length; i++) {
							if (this.AddPro[i].QX_TJ && this.AddPro[i].TJsum <= (this.AddPro[i].F_UnitRate * this
									.AddPro[i].num)) {
								this.AddPro[i].price = this.AddPro[i].TJ_Price
							} else {
								this.AddPro[i].price = this.AddPro[i].PT_Price
							}
						}
					}
				})
			},
			//导出商品详情
			ExportPro() {
				/*var data = []
				for(var i=0;i<this.ProList.length;i++){
					var adddata={
						"编码":this.ProList[i].ProductCode,
						"名称":this.ProList[i].ProductName,
						"规格型号":this.ProList[i].Standard,
						"下单类型":this.ProList[i].OrderType,
						"单位":this.ProList[i].Unit,
						"换算率":this.ProList[i].stdd,
						"件数":this.ProList[i].Number,
						"销售单价":this.ProList[i].YProPrice,
						"折后单价":this.ProList[i].ProPrice,
						"销售原始金额":this.ProList[i].YTotalPrice,
						"折后金额":this.ProList[i].TotalPrice,
						"备注":this.ProList[i].Remarks
					}
					data.push(adddata)
					
				}
				request({
					url: '/DRPORDERAPI.ashx?a=export',
					method: 'POST',
					data: {
						data: JSON.stringify(data)
					}
				}).then(res => {
					console.log(res)
				})*/
				var reportTitle = Date.parse(new Date()) + '.xlsx'
				/* generate workbook object from table */
				// 判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去，
				var fix = document.querySelector('#outTable .el-table__fixed-right');
				var wb;
				var xlsxParam = {
					raw: true
				}; //转换成excel时，使用原始的格式
				if (fix) {
					console.log(fix)
					console.log(document.querySelector('#outTable'))
					wb = XLSX.utils.table_to_book(document.querySelector('#outTable').removeChild(fix), xlsxParam);
					document.querySelector('#outTable').appendChild(fix);
				} else {
					wb = XLSX.utils.table_to_book(document.querySelector('#outTable'), xlsxParam);
				}
				/* get binary string as output */
				var wbout = XLSX.writeFile(wb, '订单产品数据.xlsx');

				return wbout;
			},
			//打印数据
			printPro() {
				this.PrintProVisible = true


			},
			onHdSubmit() {
				this.loading = 1
				request({
					url: '/DRPORDERAPI.ashx?a=gethdpagelist',
					method: 'POST',
					data: {
						hdpagination: JSON.stringify(this.Hdpagination),
						hdqueryJson: JSON.stringify({
							keyword: this.Hdkeyword,
						})
					}
				}).then(res => {
					this.loading = 0
					this.AddHdPro = res.data.rows
					this.Hdpagination.page = res.data.page
					this.Hdpagination.records = res.data.records
					this.Hdpagination.total = res.data.total
					var adddata = "";
					this.AddHdPro.forEach(item => {
						adddata += item.F_ProductCode + '@'
					})
					adddata = adddata.substring(0, adddata.length - 1)
					request({
						url: '/DRPORDERAPI.ashx?a=gethdlvpriceinfo',
						method: 'post',
						data: {
							F_ProductId: adddata,
							F_CustomerId: this.$store.state.user.F_CustomerId,
						}
					}).then(res => {
						for (var j = 0; j < this.AddHdPro.length; j++) {
							this.AddHdPro[j].lvprice = []
							for (var i = 0; i < res.data.length; i++) {
								if (this.AddHdPro[j].F_ProductCode == res.data[i].cinvcode) {
									this.AddHdPro[j].lvprice.push(res.data[i])
								}
							}
							for (var i = this.AddHdPro[j].lvprice.length - 1; i >= 0; i--) {
								if (this.AddHdPro[j].num >= Math.ceil(this.AddHdPro[j].lvprice[i].lvwhere /
										this.AddHdPro[j].F_UnitRate)) {
									this.AddHdPro[j].price = this.AddHdPro[j].lvprice[i].lvprice
									break;
								}
							}
						}

					})
				})
			},
			//打开活动商品
			OpenHdPro() {
				this.loading = 1
				this.HdProVisible = true
				//this.tableheight = (document.documentElement.clientHeight - 240) + "px"
				this.Hdpagination.page = 1
				this.onHdSubmit()
			},
			//打开选择商品对话框
			OpenPro() {
				//alert(3333)
				this.addproloading = true
				this.ProVisible = true
				//this.tableheight = (document.documentElement.clientHeight - 240) + "px"
				this.pagination.page = 1
				this.onSubmit()
			},
			//优惠价格
			numprice(val) {
			
				var sum = val.num * val.F_UnitRate
				if (val.QX_TJ && val.TJsum != null) {
					if (this.value == "QX_TJ" && sum < val.TJsum) {
						/*this.value = 'QX_PT'
						val.price=val.PT_Price*/
						this.$confirm("该商品特价起订量为" + Math.ceil(val.TJsum / val.F_UnitRate) + '件，是否将下单类型转为普通', '提示', {
							confirmButtonText: '转成普通',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.value = 'QX_PT'
							val.price = val.PT_Price
							this.count()
						}).catch(() => {
							val.price = val.PT_Price
							this.count()
						});
						//this.$message.error("该商品特价起订量为" + val.TJsum + '，已为您将下单类型转为普通')
					} else if (this.value == "QX_PT" && sum >= val.TJsum) {
						this.$confirm('该商品拥有特价，特价起订量为' + Math.ceil(val.TJsum / val.F_UnitRate) + '件，是否需要将下单类型转成特价?',
						'提示', {
							confirmButtonText: '转成特价',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.value = 'QX_TJ'
							val.price = val.TJ_Price
							this.count()
						}).catch(() => {
							val.price = val.PT_Price
							this.count()
						});
					} else if (this.value == "QX_TJ" && sum >= val.TJsum) {
						val.price = val.TJ_Price
						this.count()
					}

				}

				if (this.value == "QX_QD") {
					val.price = val.QD_Price
					for (var j = val.lvprice.length - 1; j >= 0; j--) {
						//this.tableData[index].F_Num >= Math.ceil(this.tableData[index].lvprice[j].lvwhere/this.tableData[index].F_UnitRate)
						if (val.num >= Math.ceil(val.lvprice[j].lvwhere / val.F_UnitRate)) {
							val.price = val.lvprice[j].lvprice
							break;
						}
					}
				}
				if (this.value == "QX_PT") {
					val.price = val.PT_Price
					for (var j = val.lvprice.length - 1; j >= 0; j--) {
						//this.tableData[index].F_Num >= Math.ceil(this.tableData[index].lvprice[j].lvwhere/this.tableData[index].F_UnitRate)
						if (val.num >= Math.ceil(val.lvprice[j].lvwhere / val.F_UnitRate)) {
							val.price = val.lvprice[j].lvprice
							break;
						}
					}
				}
				this.count()
			},
			//更改活动产品
			changehdnum(row) {

				if (row.lvprice != "") {
					row.price = row.PT_Price
					row.yprice = row.PT_Price
					for (var j = row.lvprice.length - 1; j >= 0; j--) {
						//this.tableData[index].F_Num >= Math.ceil(this.tableData[index].lvprice[j].lvwhere/this.tableData[index].F_UnitRate)
						if (row.num >= Math.ceil(row.lvprice[j].lvwhere / row.F_UnitRate)) {
							row.price = row.lvprice[j].lvprice
							row.yprice = row.lvprice[j].lvprice
							break;
						}
					}
				}
			},
			//选择活动产品
			SaveHdPro(row) {
				row.F_Disabled = true
				var same = 0;
				var that = this
				for (var j = 0; j < this.ProList.length; j++) {
					if (this.ProList[j].ProductCode == row.F_ProductCode && row.F_ProductName.indexOf("定制画") == -1) {
						same = 1
						this.$message({
							message: '已有相同产品，无法添加。修改数量请在订单中修改。',
							type: 'error'
						});
						row.F_Disabled = false
						break;
					}
				}
				var totalprice = row.num * row.F_UnitRate * parseFloat(row.price)
				if (same == 0) {
					this.$message({
						message: '添加成功',
						type: 'success'
					});
					var data = {
						ProductCode: row.F_ProductCode,
						ProductName: row.F_ProductName,
						Standard: row.F_SpecText,
						Unit: row.F_UnitText,
						stdd: row.整件规格,
						onenum: row.F_UnitRate,
						Number: row.num,
						sumnum: row.num * row.F_UnitRate,
						YProPrice: parseFloat(parseFloat(row.price).toFixed(2)),
						ProPrice: parseFloat(parseFloat(row.price).toFixed(2)),
						TotalPrice: (totalprice).toFixed(2),
						YTotalPrice: (totalprice).toFixed(2),
						onetiji: parseFloat(row.onetiji).toFixed(2),
						suntiji: parseFloat(parseFloat(row.onetiji) * parseFloat(row.num) * parseFloat(row.F_UnitRate)
							.toFixed(
								2)),
						Remarks: "",
						Protype: row.商品属性,
						oldcode: row.老编码,
						isCX: row.isCX,
						lvprice: row.lvprice,
						filepath: row.filepath,
						filetype: row.filetype,
						filename: row.filename,
						PT_Price: parseFloat(parseFloat(row.price).toFixed(2)),
						spcode: row.spcode.toString(),
						OrderType: "QX_HD",
						QX_HD: "True",
						TJsum: row.TJsum,
						整件规格: row.整件规格,

					}
					this.ProList.push(data)
					this.Add = false
					row.F_Disabled = false
					var sum = 0
					for (var i = 0; i < this.ProList.length; i++) {
						this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[
							i].onenum)).toFixed(
							2))
						this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i]
							.ProPrice)).toFixed(
							2)
						this.ProList[i].YTotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i]
							.YProPrice)).toFixed(
							2)
						this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i]
								.onetiji))
							.toFixed(2)
						sum += parseFloat(this.ProList[i].TotalPrice)
					}
					this.Info.TotalMoney = parseFloat(sum.toFixed(2))
					this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2)


				}

			},
			//选择产品
			SavePro(row) {
				row.F_Disabled = true
				var same = 0;
				for (var j = 0; j < this.ProList.length; j++) {
					if (this.ProList[j].ProductCode == row.F_ProductCode && row.F_ProductName.indexOf("定制画") == -1) {
						same = 1
						this.$message({
							message: '已有相同产品，无法添加。修改数量请在订单中修改。',
							type: 'error'
						});
						row.F_Disabled = false
						break;
					}
				}
				var totalprice = row.num * row.F_UnitRate * parseFloat(row.price)

				if (same == 0) {

					this.$message({
						message: '添加成功',
						type: 'success'
					});
					request({
						url: '/DRPORDERAPI.ashx?a=getaddproinfo',
						method: 'get',
						data: {
							F_ProductId: row.F_ProductCode,
							//F_CustomerId: this.$store.state.user.F_CustomerId,
							OrderType: this.value,
							price: row.price
						}
					}).then(res => {
						var data = {
							ProductCode: res.data.ProductCode,
							ProductName: res.data.ProductName,
							Standard: res.data.Standard,
							Unit: res.data.Unit,
							stdd: res.data.stdd,
							onenum: parseFloat(parseFloat(res.data.onenum).toFixed(2)),
							Number: parseFloat(row.num).toFixed(0),
							sumnum: parseFloat(parseFloat(row.num * res.data.onenum).toFixed(2)),
							yuanjia: parseFloat(parseFloat(res.data.yuanjia).toFixed(2)),
							YProPrice: parseFloat(parseFloat(row.price).toFixed(2)),
							ProPrice: parseFloat(parseFloat(row.price).toFixed(2)),
							TotalPrice: parseFloat(totalprice).toFixed(2),
							YTotalPrice: parseFloat((parseFloat(res.data.YProPrice) * row.num * res.data
								.onenum).toFixed(2)),
							onetiji: parseFloat(parseFloat(res.data.onetiji).toFixed(2)),
							suntiji: parseFloat(parseFloat(res.data.onetiji * row.num * res.data.onenum)
								.toFixed(2)),
							Remarks: "",
							Protype: res.data.Protype,
							oldcode: res.data.oldcode,
							isCX: res.data.isCX,
							lvprice: row.lvprice,
							filepath: row.filepath,
							filetype: row.filetype,
							filename: row.filename,
							QX_DS: res.data.QX_DS,
							QX_PJ: res.data.QX_PJ,
							QX_PT: res.data.QX_PT,
							QX_QD: res.data.QX_QD,
							QX_TJ: res.data.QX_TJ,
							QX_WL: res.data.QX_WL,
							QX_HD: "False",
							PT_Price: res.data.PT_Price,
							QD_Price: res.data.QD_Price,
							DS_Price: res.data.DS_Price,
							TJ_Price: res.data.TJ_Price,
							WL_Price: res.data.WL_Price,
							PJ_Price: res.data.PJ_Price,
							OrderType: res.data.OrderType,
							TJsum: row.TJsum,
							整件规格: row.整件规格,
							spcode: null,
						}
						if (res.data.yuanjia == undefined || res.data.yuanjia == "" || res.data.yuanjia == null ||
							isNaN(res.data.yuanjia)) {
							this.$message.error("网络错误，请重新选入产品")
							return false
						}
						this.ProList.push(data)
						row.F_Disabled = false
						var sum = 0
						for (var i = 0; i < this.ProList.length; i++) {
							if (this.ProList[i].OrderType == 'QX_TJ') {
								if (this.ProList[i].TJsum > this.ProList[i].sumnum) {
									this.ProList[i].ProPrice = this.ProList[i].PT_Price
									//this.ProList[i].OrderType='QX_PT'
								} else {
									this.ProList[i].ProPrice = this.ProList[i].TJ_Price
									//this.ProList[i].OrderType='QX_TJ'
								}
							}


							this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(
								this.ProList[i].onenum)).toFixed(
								2))
							this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this
								.ProList[i].ProPrice)).toFixed(
								2)
							this.ProList[i].YTotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this
								.ProList[i].YProPrice)).toFixed(
								2)
							this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this
									.ProList[i].onetiji))
								.toFixed(2)
							sum += parseFloat(this.ProList[i].TotalPrice)
						}
						this.Info.TotalMoney = parseFloat(sum.toFixed(2))
						this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney))
							.toFixed(2)
						/* var sum = 0
						for (var i = 0; i < this.ProList.length; i++) {
							this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onenum)).toFixed(
								2))
							this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].ProPrice)).toFixed(2)
							this.ProList[i].suntiji = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onetiji)).toFixed(
								2))
							sum += parseFloat(this.ProList[i].TotalPrice)
						}
						this.Info.TotalMoney = parseFloat(parseFloat(sum.toFixed(2)))
						this.Info.paymoney = parseFloat((parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2)) */
					})
				}



				//this.ProVisible = false
			},
			//关闭对话框
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			//tab切换
			handleClick(tab, event) {
				if (tab.label == "发货信息" && this.Ship == "") {
					this.OrderShip()
				} else if (tab.label == "物流信息" && this.Wuliu == "") {
					this.OrderWuliu()
				}
			},
			//订单流程获取
			OrderFlow() {
				request({
					url: '/DRPORDERAPI.ashx?a=getflowsetting',
					method: 'get',
					data: {
						F_OrderCode: this.BillsNumber
					}
				}).then(res => {
					this.flowSetting = res.data.list
					this.flow.F_Step = parseInt(res.data.info)
					this.isAppeal = res.data.isAppeal;
					this.flowappeal = res.data.appeal
					this.flow.F_AppealStep = parseInt(res.data.appealinfo)

				})
			},
			//订单详情获取
			OrderDetail() {
				this.totalloading = true
				this.Tableheight = (document.documentElement.clientHeight - 350) + "px"
				request({
					url: '/DRPORDERAPI.ashx?a=getdetail',
					method: 'get',
					data: {
						F_OrderCode: this.BillsNumber
					}
				}).then(res => {
					this.totalloading = false
					this.loading = false
					this.ProList = res.data.list
					this.Info = res.data.info
					this.ishd = res.data.ishd
					console.log(res.data.list)
					if (this.Info.spcode == null || this.Info.spcode == undefined || this.Info.spcode.toString() ==
						'') {
						this.hdAdd = false
						this.Add = true
					} else {
						this.hdAdd = true
						this.Add = false
					}
					for (var i = 0; i < this.ProList.length; i++) {
						this.ProList[i].Number = parseFloat(this.ProList[i].Number)
						this.ProList[i].sumnum = parseFloat(this.ProList[i].sumnum)

						if (this.ProList[i].OrderType == 'QX_QD' || (this.ProList[i].spcode != null && this
								.ProList[i].spcode.toString() != "")) {
							for (var j = this.ProList[i].lvprice.length - 1; j >= 0; j--) {
								if (this.ProList[i].Number >= Math.ceil(this.ProList[i].lvprice[j].lvwhere / this
										.ProList[i].onenum)) {
									this.ProList[i].ProPrice = this.ProList[i].lvprice[j].lvprice
									this.ProList[i].YProPrice = this.ProList[i].lvprice[j].lvprice
									break;
								}
							}
						}

					}
				})
			},
			//产品分页
			handleSizeChange(newSize) {
				this.pagination.rows = newSize;
				this.onSubmit();
			},
			handleCurrentChange(newPage) {
				this.pagination.page = newPage;
				this.onSubmit();
			},
			hdhandleSizeChange(newSize) {
				this.Hdpagination.rows = newSize;
				this.onHdSubmit()();
			},
			hdhandleCurrentChange(newPage) {
				this.Hdpagination.page = newPage;
				this.onHdSubmit();
			},
			//更改数量
			detailEdit(row,colname) {
				// if(colname=="sumnum")
				// {
				// 	if(row.sumnum==0)
				// 	{
				// 		row.sumnum=1
						
				// 	}
				// 	row.Number=row.sumnum/row.onenum					
				// }
				// var num = row.Number
				
				if (colname == "sumnum") {
					if (Math.floor(row.sumnum) == 0) {
						row.sumnum = 1
					}
					if (row.sumnum  % 1 != 0 &&row.Unit!="米" &&row.Unit!="平方米") {
						this.$message.error("数量只能输入整数!")
						row.sumnum = Math.floor(row.sumnum );
					}
					else
					{
						row.sumnum = parseFloat(parseFloat( row.sumnum).toFixed(2));
						
					}
					row.Number = row.sumnum / row.onenum
				}
				if (colname == "Number") {
					var num = parseFloat(row.Number);
					if (Math.floor(row.Number) == 0) {
						row.Number = 1
					}
					if (num % 1 != 0 &&row.Unit!="米" &&row.Unit!="平方米") {
						this.$message.error("件数只能输入整数!")
						row.Number = Math.floor(num);
					}else
					{
						row.Number = parseFloat( num.toFixed(2));
						
					}
				}
				// var num = Math.floor(row.Number)
				// if (num == 0) {
				// 	row.Number = 1
				// 	num = 1
				// }
				var code = row.ProductCode
				var type = row.OrderType
				var sum = 0;
				var change = 0

				if (row.QX_TJ == "True") {
					if (row.OrderType == "QX_TJ" && row.Number * row.onenum < row.TJsum) {
						// this.$confirm("该商品特价起订量为" + Math.ceil(row.TJsum / row.onenum) + '，是否将下单类型转为普通', '提示', {
						// 	confirmButtonText: '转成普通',
						// 	cancelButtonText: '取消',
						// 	type: 'warning'
						// }).then(() => {

						// 	row.OrderType = 'QX_PT'
						// 	row.ProPrice = row.PT_Price
						// 	row.YProPrice = row.PT_Price
						// 	this.count()
						// }).catch(() => {
						// 	row.YProPrice = row.PT_Price
						// 	this.count()
						// });
							row.OrderType = 'QX_PT'
							row.ProPrice = row.PT_Price
							row.YProPrice = row.PT_Price
							this.count()
						// row.OrderType = 'QX_PT'
						// row.ProPrice=row.PT_Price
						// row.YProPrice=row.PT_Price
						// this.$message.error("该商品特价起订量为" + row.TJsum + '，已为您将下单类型转为普通')
					} else if (row.OrderType == "QX_PT" && row.Number * row.onenum >= row.TJsum) {
						
							this.$confirm('该商品拥有特价，特价起订量为' + Math.ceil(row.TJsum / row.onenum) + '是否需要将下单类型转成特价?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								row.OrderType = 'QX_TJ'
								row.ProPrice = row.TJ_Price
								row.YProPrice = row.TJ_Price
								this.count()
								this.$set(row, 'isremind', 1)
							}).catch(() => {
								row.ProPrice = row.PT_Price
								row.YProPrice = row.PT_Price
								this.$set(row, 'isremind', 1)
								this.count()
							});
						
					} else if (row.OrderType == "QX_TJ" && row.Number * row.onenum >= row.TJsum*1) {
						
						console.log(row.TJ_Price);
						row.ProPrice = row.TJ_Price
						row.YProPrice = row.TJ_Price
						this.count()
						console.log(row.ProPrice);
						
					}
				}

				if (row.QX_QD == "True" || (row.spcode != null  && row.spcode != undefined&&row.spcode != "")) {
					
					if (type == "QX_QD" || (row.spcode != null  && row.spcode != undefined&&row.spcode != "")) {
						for (var j = row.lvprice.length - 1; j >= 0; j--) {
							if (parseInt(num * row.onenum) >= parseInt(row.lvprice[j].lvwhere)) {
								row.YProPrice = row.lvprice[j].lvprice
								row.ProPrice = row.lvprice[j].lvprice
								change = 1
								break;
							}

						}
						if (change == 0) {
							row.YProPrice = row.QD_Price
							row.ProPrice = row.QD_Price
						}
						if ((row.spcode != null  && row.spcode != undefined&&row.spcode != "") && change == 0) {
							row.YProPrice = row.PT_Price
							row.ProPrice = row.PT_Price
						}
					}
				}
				if (row.QX_PT == "True" || (row.spcode != null  && row.spcode != undefined&&row.spcode != "")) {
					
					if (type == "QX_PT" || (row.spcode != null  && row.spcode != undefined&&row.spcode != "")) {
						for (var j = row.lvprice.length - 1; j >= 0; j--) {
							if (parseInt(num * row.onenum) >= parseInt(row.lvprice[j].lvwhere)) {
								row.YProPrice = row.lvprice[j].lvprice
								row.ProPrice = row.lvprice[j].lvprice
								change = 1
								break;
							}
				
						}
						if (change == 0) {
							row.YProPrice = row.PT_Price
							row.ProPrice = row.PT_Price
						}
						if ((row.spcode != null  && row.spcode != undefined&&row.spcode != "") && change == 0) {
							row.YProPrice = row.PT_Price
							row.ProPrice = row.PT_Price
						}
					}
				}
				this.count()

				/* for (var i = 0; i < this.ProList.length; i++) {
					if (this.ProList[i].ProductCode == code) {
						this.ProList[i].Number = num
						this.ProList[i].YProPrice = row.YProPrice
						this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onenum)).toFixed(
							2))
						this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].ProPrice)).toFixed(
							2)
						this.ProList[i].suntiji = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onetiji)).toFixed(
							2))
					}
					sum += parseFloat(this.ProList[i].TotalPrice)
				}
				this.Info.TotalMoney = parseFloat(sum.toFixed(2))
				this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2) */
			},
			//更改产品属性
			OrderTypeChange(row) {
				
				if (row.OrderType == "QX_PT") {
					row.YProPrice = row.PT_Price
					row.ProPrice = row.PT_Price
				} else if (row.OrderType == "QX_TJ") {
					if (row.TJsum > row.sumnum) {
						row.YProPrice = row.PT_Price
						row.ProPrice = row.PT_Price
						//row.OrderType='QX_PT'
					} else {
						row.YProPrice = row.TJ_Price
						row.ProPrice = row.TJ_Price
						//row.OrderType='QX_TJ'
					}
					//row.YProPrice = row.TJ_Price
				} else if (row.OrderType == "QX_DS") {
					row.YProPrice = row.DS_Price
					row.ProPrice = row.DS_Price
				} else if (row.OrderType == "QX_QD") {
					row.YProPrice = row.QD_Price
					row.ProPrice = row.QD_Price
					for (var j = row.lvprice.length - 1; j >= 0; j--) {
						if (row.ProductCode == row.ProductCode) {
							if (parseInt(row.Number * row.onenum) >= parseInt(row.lvprice[j].lvwhere)) {
								row.YProPrice = row.lvprice[j].lvprice
								row.ProPrice = row.lvprice[j].lvprice
								break;
							}
						}
					}
				} else if (row.OrderType == "QX_WL") {
					row.yYProPrice = row.WL_Price
					row.ProPrice = row.WL_Price
				} else if (row.OrderType == "QX_PJ") {
					row.YProPrice = row.PJ_Price
					row.ProPrice = row.PJ_Price
				}
				this.count()
			},
			//删除产品
			deletePro(code) {
				var sum = 0;
				for (var i = 0; i < this.ProList.length; i++) {
					if (code == this.ProList[i]) {
						this.delPro.push(this.ProList[i])
						this.ProList.splice(i, 1)
						break;
					}
				}
				if (this.ProList.length == 0) {
					if (this.Info.spcode == null || this.Info.spcode == undefined || this.Info.spcode.toString() == '') {
						this.hdAdd = false
						this.Add = true
					} else {
						this.hdAdd = true
						this.Add = false
					}
					//this.hdAdd = true
					//this.Add = true
					this.Hdkeyword = ""
					this.keyword = ""
					//this.Info.spcode=null
				}
				this.count()
				/* for (var i = 0; i < this.ProList.length; i++) {
					this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onenum)).toFixed(
						2))
					this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].ProPrice)).toFixed(2)
					this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onetiji)).toFixed(2)
					sum += parseFloat(this.ProList[i].TotalPrice)
				}
				this.Info.TotalMoney = parseFloat(sum.toFixed(2))
				this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2) */
			},
			//总计
			getSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总计';
						return;
					}
					if (index === 2 || index === 3 || index === 5 || index === 7 ) {
						const values = data.map(item => Number(item[column.property]));
						if (!values.every(value => isNaN(value))) {
							sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);

								if (!isNaN(value)) {
									return prev + curr;
								} else {
									return prev;
								}
							}, 0);

							sums[index] = parseFloat(parseFloat(sums[index]).toFixed(2))
						}
					}
				});
				return sums;
			},
			//发货信息获取
			OrderShip() {
				this.shiploading = true
				this.orderloading = true
				request({
					url: '/DRPORDERAPI.ashx?a=gettopship',
					method: 'get',
					data: {
						F_OrderCode: this.BillsNumber //'PT00000271' //this.$route.query.F_OrderCode
					}
				}).then(res => {
					this.shiploading = false
					this.orderloading = false
					this.ShipList = res.data.list
				})
			},
			//查看发货信息
			lookupShip(row, column, event) {
				this.orderloading = true
				request({
					url: '/DRPORDERAPI.ashx?a=getbottomship',
					method: 'get',
					data: {
						cdlcode: row.cDLCode
					}
				}).then(res => {
					this.orderloading = false
					this.OrderList = res.data.list
				})
			},
			//打印发货信息
			printShip(row) {
				var cDLCode = row.cDLCode
				var code = this.BillsNumber
				request({
					url: '/DRPORDERAPI.ashx?a=getprintship',
					method: 'get',
					data: {
						code: code,
						cdlcode: cDLCode
					}
				}).then(res => {
					if (res.code == 200) {
						this.printList = res.data.row
						this.printForm = res.data.data
					} else {
						this.$message({
							type: 'error',
							message: res.info
						});
					}
				})
				this.PrintVisible = true


				//window.print()
			},
			//打印
			print() {
				window.print()
			},
			//删除发货信息
			delShip(row, column, event) {
				this.$confirm('是否确认删除?', '提示', {
					confirmButtonText: '删除',
					cancelButtonText: '取消',
					type: 'info'
				}).then(() => {
					request({
						url: '/DRPORDERAPI.ashx?a=delship',
						method: 'get',
						data: {
							cDLCode: row.cDLCode,
							F_CustomerId: this.$store.state.user.F_CustomerId,
						}
					}).then(res => {
						this.wuliuloading = false
						this.Wuliu = res.data.list
					})

				}).catch(() => {

				});
			},
			//物流信息获取
			OrderWuliu() {
				this.wuliuloading = true
				request({
					url: '/DRPORDERAPI.ashx?a=getwuliu',
					method: 'get',
					data: {
						F_OrderCode: this.BillsNumber
					}
				}).then(res => {
					this.wuliuloading = false
					this.Wuliu = res.data.list
				})
			},
			//修改按钮
			EditChange() {
				var that = this
				if (this.isEdit == 0) {
					this.$confirm('修改订单将删除原订单所有优惠,并且去除所有龙骨配提,并在保存时重新生成,确定要继续吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'info'
					}).then(() => {
						const loading = this.$loading({
							lock: true,
							text: 'Loading',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						request({
							url: '/DRPORDERAPI.ashx?a=deletefl',
							method: 'post',
							data: {
								F_OrderCode: this.BillsNumber,
							}
						}).then(res => {
							loading.close();
							if (res.data == 1) {
								that.isEdit = !that.isEdit

								for (var i = 0; i < this.ProList.length; i++) {
									this.ProList[i].ProPrice = this.ProList[i].YProPrice
									this.ProList[i].TotalMoney = parseFloat(this.ProList[i].YProPrice) *
										parseFloat(this.ProList[i].sumnum)
								}
								this.Info.payment = this.Info.TotalMoney
								this.Info.flmoney = 0

								//this.$router.push('/order/order?F_OrderCode='+this.$route.query.F_OrderCode)
							}
						})
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消修改'
						});
					});
				} else {
					this.isEdit = !this.isEdit
				}
			},
			//提交订单
			SubmitOrder() {
				request({
					url: '/DRPORDERAPI.ashx?a=computesubmit',
					method: 'get',
					data: {
						F_OrderCode: this.BillsNumber,
						key: 0,
					}
				}).then(res => {
					if (res.code == 200) {
						if (res.account.split(",").length > 1) {
							this.SubmitVisible = true
							this.SubmitData.ordermoney = this.Info.TotalMoney
							this.SubmitData.orderflmoney = this.Info.flmoney
							this.SubmitData.orderpaymoney = this.Info.paymoney
							this.SubmitData.pt = res.info.split(",")[0]
							this.SubmitData.ptmoney = res.account.split(",")[2]
							this.SubmitData.ptbalance =(parseFloat(res.info.split(",")[0]) -parseFloat(res.account.split(",")[2])).toFixed(2)
							this.SubmitData.fl = res.info.split(",")[1]
							this.SubmitData.flmoney = this.Info.flmoney
							this.SubmitData.flbalance =(parseFloat(res.info.split(",")[1]) -parseFloat(this.Info.flmoney)).toFixed(2)
							this.SubmitData.pj = res.info.split(",")[2]
							this.SubmitData.pjmoney = res.account.split(",")[0]
							this.SubmitData.pjbalance =(parseFloat(res.info.split(",")[2]) -parseFloat(res.account.split(",")[0])).toFixed(2)
							this.SubmitData.wl = res.info.split(",")[3]
							this.SubmitData.wlmoney = res.account.split(",")[1]
							this.SubmitData.wlbalance =(parseFloat(res.info.split(",")[3]) -parseFloat(res.account.split(",")[1])).toFixed(2)
						} else {
							this.hdSubmitVisible = true

							this.SubmitData.ordermoney = this.Info.TotalMoney
							this.SubmitData.orderflmoney = this.Info.flmoney
							this.SubmitData.orderpaymoney = this.Info.paymoney
							this.SubmitData.hd = res.info
							this.SubmitData.hdmoney = res.account
						}

						//this.SubmitData = res.data
					} else {
						this.$message({
							type: 'error',
							message: res.info
						});
					}
				})
			},
			//确认提交
			Submit() {
				this.$confirm('是否确认提交订单?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'info'
				}).then(() => {
					const loading = this.$loading({
						lock: true,
						text: 'Loading',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					request({
						url: '/DRPORDERAPI.ashx?a=submitorder',
						method: 'post',
						data: {
							F_OrderCode: this.BillsNumber,
							key: 0,
							//F_CustomerId: this.$store.state.user.F_CustomerId,
						}
					}).then(res => {
						loading.close();
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: '提交成功'
							});
							this.SubmitVisible = false
							this.hdSubmitVisible = false
							this.onload()
							// var account = res.account.split(",")
							// this.$alert("提交成功!配件子账户扣款" + account[0] + ",物料账户扣款" + account[1] + ",普通账户扣款" + account[2], '账户扣款情况', {
							// 	confirmButtonText: '确定',
							// 	callback: action => {
							// 		this.$router.go(0)
							// 	}
							// });
						} else {
							if (res.info.indexOf('物料库存不足,是否提交') != -1) {
								this.submitAgain(res.info)
							} else {
								this.$message({
									type: 'error',
									message: res.info
								});
							}
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消提交'
					});
				});
			},
			//库存不足继续提交
			submitAgain(res) {
				//库存不足
				this.$confirm(res, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					const loading = this.$loading({
						lock: true,
						text: 'Loading',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					//继续提交传入方法
					request({
						url: '/DRPORDERAPI.ashx?a=submitorder',
						method: 'post',
						data: {
							F_OrderCode: this.BillsNumber,
							key: 1,
							//F_CustomerId: this.$store.state.user.F_CustomerId,
						}
					}).then(res => {
						loading.close();
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: '提交成功!'
							});
							//this.$router.push('/order/order?F_OrderCode='+this.$route.query.F_OrderCode)
							//this.$router.go(0)
							this.onload()
						} else {
							if (res.info.indexOf('物料库存不足,是否提交')) {
								this.submitAgain()
							} else {
								this.$message({
									type: 'error',
									message: res.info
								});
							}
						}
					})
					//继续提交传入方法
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消提交'
					});
				});
				//库存不足
			},
			//申请定制
			AppealCustomized() {
				this.$confirm('正常商品使用定制申请会影响发货时间,请确保此订单属于定制产品,是否确定定制申请?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'info'
				}).then(() => {
					const loading = this.$loading({
						lock: true,
						text: 'Loading',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					request({
						url: '/DRPORDERAPI.ashx?a=applycommission',
						method: 'post',
						data: {
							//F_CustomerId: this.$store.state.user.F_CustomerId,
							BillsNumber: this.BillsNumber
						}
					}).then(res => {
						loading.close();
						if (res.code == 200) {
							//this.$router.push('/order/order?F_OrderCode='+code)
							this.onload()
						} else {
							this.$message({
								message: res.info,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消申请'
					});
				});



			},
			//工程申请
			AppealCustomizedGC() {
				this.$confirm('正常商品使用工程申请会影响发货时间,请确保此订单属于工程产品,是否确定工程申请?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'info'
				}).then(() => {
					const loading = this.$loading({
						lock: true,
						text: 'Loading',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					request({
						url: '/DRPORDERAPI.ashx?a=applycommissionGC',
						method: 'post',
						data: {
							//F_CustomerId: this.$store.state.user.F_CustomerId,
							BillsNumber: this.BillsNumber
						}
					}).then(res => {
						loading.close();
						if (res.code == 200) {
							//this.$router.push('/order/order?F_OrderCode='+code)
							this.onload()
						} else {
							this.$message({
								message: res.info,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消申请'
					});
				});
			
			
			
			},
			//撤回申请
			AppealReturn() {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				request({
					url: '/DRPORDERAPI.ashx?a=applyreturn',
					method: 'post',
					data: {
						//F_CustomerId: this.$store.state.user.F_CustomerId,
						BillsNumber: this.BillsNumber
					}
				}).then(res => {
					loading.close();
					if (res.code == 200) {
						//this.$router.push('/order/order?F_OrderCode='+code)
						this.onload()
					} else {
						this.$message({
							message: res.info,
							type: 'error'
						});
					}
				})
			},
			//确认收货
			OrderSuccess() {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				request({
					url: '/DRPORDERAPI.ashx?a=receiptorder',
					method: 'post',
					data: {
						//F_CustomerId: this.$store.state.user.F_CustomerId,
						BillsNumber: this.BillsNumber
					}
				}).then(res => {
					loading.close();
					if (res.code == 200) {
						//this.$router.push('/order/order?F_OrderCode='+code)
						this.onload()
					} else {
						this.$message({
							message: res.info,
							type: 'error'
						});
					}
				})
			},
			select(selection, row) {
				var isselect = 0;
				var that = this
				selection.forEach(el => {
					if (row.ProductCode == el.ProductCode) {
						isselect = 1
					}
				})
				if (isselect == 1) {
					if (row.children != undefined) {
						row.children.forEach(i => {
							that.$refs.matchtable.toggleRowSelection(i, true)
						})
					}
				} else {
					if (row.children != undefined) {
						row.children.forEach(i => {
							that.$refs.matchtable.toggleRowSelection(i, false)
						})
					}
				}
			},
			selectall(selection) {
				var that = this
				selection.forEach(el => {
					if (el.children == undefined) {
						that.$refs.matchtable.toggleRowSelection(el, false)
					}
				})

				if (selection.length != 0) {
					selection.forEach(el => {
						if (el.children != undefined) {
							el.children.forEach(i => {
								that.$refs.matchtable.toggleRowSelection(i, true)
							})
						}
					})
				}

			},
			//更改配套产品数量
			matchEdit(row, type) {
				if (type == "sumnum") {
					row.Number = parseFloat((parseFloat(row.sumnum) / parseFloat(row.onenum)).toFixed(2))

				} else {
					row.sumnum = parseFloat((parseFloat(row.onenum) * parseFloat(row.Number)).toFixed(2))
				}
				row.sumnum = parseFloat((parseFloat(row.Number) * parseFloat(row.onenum)).toFixed(2))
				row.TotalPrice = (parseFloat(row.Number) * parseFloat(row.onenum) *
					parseFloat(row.ProPrice)).toFixed(2)
				row.YTotalPrice = (parseFloat(row.Number) * parseFloat(row.onenum) *
					parseFloat(row.YProPrice)).toFixed(2)
				row.suntiji = (parseFloat(row.Number) * parseFloat(row.onetiji)).toFixed(2)
				for (var i = 0; i < this.ProMatch.length; i++) {
					this.ProMatch[i].sumnum = parseFloat((parseFloat(this.ProMatch[i].Number) * parseFloat(this.ProMatch[i]
						.onenum)).toFixed(
						2))
					this.ProMatch[i].TotalPrice = (parseFloat(this.ProMatch[i].Number) * parseFloat(this.ProMatch[i]
							.onenum) *
						parseFloat(this.ProMatch[i].ProPrice)).toFixed(2)
					this.ProMatch[i].YTotalPrice = (parseFloat(this.ProMatch[i].Number) * parseFloat(this.ProMatch[i]
							.onenum) *
						parseFloat(this.ProMatch[i].YProPrice)).toFixed(2)
					this.ProMatch[i].suntiji = (parseFloat(this.ProMatch[i].Number) * parseFloat(this.ProMatch[i].onetiji))
						.toFixed(2)
				}
			},
			//保存配套产品至订单中
			SaveProMatch() {
				var that = this
				var hasnum = 0
				var hassame = 0;
				this.$refs.matchtable.selection.forEach(el => {
					if (el.sumnum == 0) {
						hasnum = 1
						return
					}
					el.spcode = null
					if (el.children == undefined) {
						var issame = 0;
						for (var i = 0; i < this.ProList.length; i++) {
							if (this.ProList[i].ProductCode == el.ProductCode) {
								issame = 1
								hassame = 1;
								break
							}
						}
						if (issame == 0) {
							this.ProList.push(el)
						}
					}
				})
				if (hassame == 1) {
					this.$message({
						message: '选择的产品已存在列表中，已为您取消加入',
						type: 'error'
					});
				}
				if (hasnum == 1) {
					this.$message({
						message: '请填写数量',
						type: 'error'
					});
					return
				}

				/* var sum = 0
				for (var i = 0; i < this.ProList.length; i++) {
					this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onenum)).toFixed(
						2))
					this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].ProPrice)).toFixed(2)
					this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onetiji)).toFixed(2)
					sum += parseFloat(this.ProList[i].TotalPrice)
				}
				this.Info.TotalMoney = parseFloat(sum.toFixed(2))
				this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2) */
				this.ProMatchVisible = false
				this.$message({
					message: '添加成功',
					type: 'success'
				});
			},
			//更改配提产品数量
			peitiEdit(row, type) {
				if (type == "sumnum") {
					row.Number = parseFloat((parseFloat(row.sumnum) / parseFloat(row.onenum)).toFixed(2))

				} else {
					row.sumnum = parseFloat((parseFloat(row.onenum) * parseFloat(row.Number)).toFixed(2))
				}
				row.sumnum = parseFloat((parseFloat(row.Number) * parseFloat(row.onenum)).toFixed(2))
				row.TotalPrice = (parseFloat(row.sumnum) * parseFloat(row.ProPrice)).toFixed(2)
				row.YTotalPrice = (parseFloat(row.sumnum) * parseFloat(row.YProPrice)).toFixed(2)
				row.suntiji = (parseFloat(row.Number) * parseFloat(row.onetiji)).toFixed(2)
				for (var i = 0; i < this.peitiData.length; i++) {
					this.peitiData[i].sumnum = parseFloat((parseFloat(this.peitiData[i].Number) * parseFloat(this
							.peitiData[i].onenum))
						.toFixed(2))
					this.peitiData[i].TotalPrice = (parseFloat(this.peitiData[i].sumnum) *
						parseFloat(this.peitiData[i].ProPrice)).toFixed(2)
					this.peitiData[i].YTotalPrice = (parseFloat(this.peitiData[i].sumnum) *
						parseFloat(this.peitiData[i].YProPrice)).toFixed(2)
					this.peitiData[i].suntiji = (parseFloat(this.peitiData[i].Number) * parseFloat(this.peitiData[i]
						.onetiji)).toFixed(
						2)
				}
			},
			//保存配提
			SavePeiti() {
				var that = this
				var hasnum = 0
				var selectionsum = 0
				var neednum = 0
				var Remarks = this.Info.Remarks
				if (this.$refs.peititable.selection.length == 0) {
					this.$message({
						message: '请选择龙骨并填写数量',
						type: 'error'
					});
					return
				}
				this.$refs.peititable.selection.forEach(el => {
					neednum = el.Sumstockbalance
					Remarks = el.Remarks
					el.spcode = null
					if (el.sumnum == 0) {
						hasnum = 1
						return
					}
					var issame = 0;
					for (var i = 0; i < this.ProList.length; i++) {
						if (this.ProList[i].ProductCode == el.ProductCode) {
							issame = 1
							break
						}
					}
					if (issame == 0) {
						el.Remarks = ""
						el.spcode = null
						selectionsum += parseFloat(el.sumnum)
						this.ProList.push(el)
					}
				})
				if (parseFloat(selectionsum) < parseFloat(neednum)) {
					this.$message({
						message: '选择数量不够，请大于' + neednum,
						type: 'error'
					});
					return
				}
				if (hasnum == 1) {
					this.$message({
						message: '请填写数量',
						type: 'error'
					});
					return
				}

				var sum = 0
				var k = 0
				/* for (var i = 0; i < this.ProList.length; i++) {
					this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onenum)).toFixed(
						2))
					this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].ProPrice)).toFixed(2)
					this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onetiji)).toFixed(2)
					sum += parseFloat(this.ProList[i].TotalPrice)
					k = i
				}
				this.Info.TotalMoney = parseFloat(sum.toFixed(2))
				this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2) */
				this.Info.Remark = Remarks
				this.peitiVisible = false
				if (k == this.ProList.length) {
					this.loading = true
					request({
						url: '/DRPORDERAPI.ashx?a=saveorderinfo',
						method: 'post',
						data: {
							rows: JSON.stringify(this.ProList),
							info: JSON.stringify(this.Info),
							delPro: JSON.stringify(this.delPro),
							//F_CustomerId: this.$store.state.user.F_CustomerId,
							F_OrderCode: this.BillsNumber
						}
					}).then(res => {
						this.loading = false
						if (res.code == 200) {

							//this.$router.push('../order/order?F_OrderCode='+code)
							this.onload()
						} else {
							this.$message({
								message: res.info,
								type: 'error'
							});
						}
					})
				}
			},
			//判断配件
			beforesave() {
				request({
					url: '/DRPORDERAPI.ashx?a=beforesave',
					method: 'Post',
					data: {
						//F_CustomerId: this.$store.state.user.F_CustomerId,
						rows: JSON.stringify(this.ProList),
					}
				}).then(res => {
					if (res.data == 1) {
						this.checkpeiti()
					} else {
						this.loading = false
						this.ProMatch = res.data
						//this.tableheight = (document.documentElement.clientHeight - 265) + "px"
						//生成主件 配件 选择弹窗
						this.ProMatchVisible = true
					}
				})
			},
			//判断配提
			checkpeiti() {
				request({
					url: '/DRPORDERAPI.ashx?a=checkpeiti',
					method: 'Post',
					data: {
						//F_CustomerId: this.$store.state.user.F_CustomerId,
						rows: JSON.stringify(this.ProList),
					}
				}).then(res => {
					if (res == null) {
						this.saveorderinfo()
					} else {
						this.loading = false
						this.peitiData = res.Rows
						//this.tableheight = (document.documentElement.clientHeight - 265) + "px"
						this.peitiVisible = true
					}
				})
			},
			//保存方法
			saveorderinfo() {
				this.loading = true
				request({
					url: '/DRPORDERAPI.ashx?a=saveorderinfo',
					method: 'post',
					data: {
						rows: JSON.stringify(this.ProList),
						info: JSON.stringify(this.Info),
						delPro: JSON.stringify(this.delPro),
						//F_CustomerId: this.$store.state.user.F_CustomerId,
						F_OrderCode: this.BillsNumber
					}
				}).then(res => {
					if (res.code == 200) {
						this.onload()
					} else {
						this.loading = false
						this.$message({
							message: res.info,
							type: 'error'
						});
					}
				})
			},
			//保存订单
			OrderSave() {
				this.loading = true
				var haswl = 0;
				var haspj = 0;
				var code = this.BillsNumber
				if (this.ProList.length == 0) {
					this.$message({
						message: "请选择产品后再保存",
						type: 'error'
					});
					this.loading = false
					return
				}
				var pt = 0,
					hd = 0;
				for (var i = 0; i < this.ProList.length; i++) {
					if (this.ProList[i].Number <= 0) {
						this.$message({
							message: this.ProList[i].ProductName + '产品数量为0，无法保存',
							type: 'error'
						});
						this.loading = false
						return
					}

					if (this.ProList[i].OrderType == "QX_TJ" && parseFloat(this.ProList[i].TJsum) > parseFloat(this
							.ProList[i].sumnum)) {
						this.$message({
							message: this.ProList[i].ProductName + '的特价起订数量为' + this.ProList[i].TJsum,
							type: 'error'
						});
						this.loading = false
						return
					}
					/* if (this.ProList[i].OrderType == "QX_PJ") {
						haspj++
					}
					if (this.ProList[i].OrderType == "QX_WL") {
						haswl++
					} */
					if (this.ProList[i].YProPrice == 0 || this.ProList[i].ProPrice == 0) {
						this.$message({
							message: this.ProList[i] + '产品价格为0，无法保存',
							type: 'error'
						});
						this.loading = false
						return
					}

					if (this.ProList[i].spcode == null || this.ProList[i].spcode.toString() == "") {
						this.Info.spcode = null
						pt++
					} else {
						this.Info.spcode = this.ProList[i].spcode
						hd++
					}
					//this.ProList[i].lvprice = "";
				}
				if (pt > 0 && hd > 0) {
					this.$message({
						message: '活动商品无法与普通商品一起下单，请删除商品重新保存',
						type: 'error'
					});
					this.loading = false
					return
				}
				/* if (haspj != 0 && haspj != this.multipleSelection.length) {
					this.$message({
						message: '配件无法与其他产品一同下单',
						type: 'error'
					});
					this.loading = false
					return
				}
				if (haswl != 0 && haswl != this.multipleSelection.length) {
					this.$message({
						message: '物料无法与其他产品一同下单',
						type: 'error'
					});
					this.loading = false
					return
				} */
				for (var i = 0; i < this.delPro.length; i++) {
					this.delPro[i].lvprice = "";
				}
				//大板
				request({
					url: '/DRPORDERAPI.ashx?a=checkdaban',
					method: 'Post',
					data: {
						//F_CustomerId: this.$store.state.user.F_CustomerId,
						rows: JSON.stringify(this.ProList),
					}
				}).then(res => {
					if (res == 1) {
						this.$confirm('蒙德里安系列大板根据所订产品中同一型号≥4<6块大板打包一个蜂窝包装箱，谢谢配合,帮您转到产品选择界面?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.loading = false
							if (this.Info.spcode == null || this.Info.spcode.toString() == "") {
								this.keyword = "包装箱"
								this.value = "QX_PT"
								this.OpenPro()
							} else {
								this.Hdkeyword = "包装箱"
								this.OpenHdPro()
							}

						}).catch(() => {
							this.loading = false
							return
						});
					} else {
						if (this.issaved == 0) {
							this.beforesave()
						} else {
							this.checkpeiti()
						}
						this.issaved = 1
					}
				})
			},
			back() {
				this.isEdit = false
				this.activeName = "Order"
				this.hdAdd = true
				this.Add = true
				this.Hdkeyword = ""
				this.keyword = ""
				this.Info.spcode = null
				this.$emit("closeOrder", false);
			},
		},
		filters: {
			showPrice(price) {
				if (!price) return '0.00';
				var intPart = Number(price) - Number(price) % 1; //获取整数部分
				var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断

				var floatPart = ".00"; //预定义小数部分
				var value2Array = price.toString().split(".");

				//=2表示数据有小数位
				if (value2Array.length == 2) {
					floatPart = value2Array[1].toString(); //拿到小数部分

					if (floatPart.length == 1) {
						return '¥' + intPartFormat + "." + floatPart + '0';
					} else {
						return '¥' + intPartFormat + "." + floatPart.substring(0, 2);
					}

				} else {
					return '¥' + intPartFormat + floatPart;
				}

			}
		}
	}
</script>

<style>
	@import "../../font/iconfont.css";

	@font-face {
		font-family: 'iconfont';
		src: url('../../font/iconfont.eot');
		src: url('../../font/iconfont.eot?#iefix') format('embedded-opentype'),
			url('../../font/iconfont.woff2') format('woff2'),
			url('../../font/iconfont.woff') format('woff'),
			url('../../font/iconfont.ttf') format('truetype'),
			url('../../font/iconfont.svg#iconfont') format('svg');
	}
	.el-card__body
	{
	padding: 5px !important;	
		
	}
	.el-dialog__body{
		padding: 5px !important;
			
	}
.el-table td,
	.el-table th.is-leaf {
		border: 1px solid #CCCCCC;
		/* border-right:  #CCCCCC;
			  border-left: 1px solid #CCCCCC; */
	}
	
	.el-table__body .el-table .cell {
		color: #000000 !important;
	
	}
	.el-pagination {
		border: 1px solid #CCCCCC;
	
	}
	.el-textarea__inner {
		min-height: 0 !important;
	}

	.iconfont {
		font-family: "iconfont" !important;
		font-size: 12px;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.img {
		width: 87px;
		height: 87px;
	}

	.l {
		display: block;
		margin-top: 10px;
	}

	/* 	.l3 {
		font-size: 16px;
		font-weight: 700;
	} */

	.flow {
		width: 110px;
		height: 100px;
		position: absolute;
		background: #e7093d;
		top: -50px;
		right: -50px;
		transform: rotate(45deg);
	}

	.a .el-breadcrumb__inner {
		color: #0081ff !important;
		font-weight: 700 !important;
	}

	.el-form-item {
		margin-bottom: 5px !important;
	}

	* {
		font-size: 12px !important;
		font-family: "Microsoft YaHei", 微软雅黑, "Microsoft JhengHei", 华文细黑, STHeiti, MingLiu
	}

	.el-breadcrumb {
		font-size: 12px;
		line-height: 1;
		margin-top: -20px;
	}

	.el-button--mini {
		padding: 5px 10px !important;
	}

	.cell {
		line-height: 2 !important;
	}

	.el-table td {
		padding: 0 !important;
	}

	.el-table th {
		padding: 0 !important;
	}

	.el-dialog__header {
		display: none !important;
	}

	/* .el-input__inner
	{
		width: 130px !important;
		padding:0 2px !important;
		    font-size:9px !important;
	} */
	/* .el-form-item__content{
		width: 130px !important;		
	} */
	/* .el-input--mini
	{
		width: 130px !important;		
	} */
</style>
